const filterInitiativesByImpactUpdate = (initiatives) => {
  const impactGroups = {
    '<not set>': [],
    'No actuals (below L3 or cancelled/on hold)': [],
    'No actuals required or no impacts': [],
    'Missing actual in FY 23-24': [],
    'Filled actual in FY 23-24': [],
  };

  initiatives.forEach((initiative) => {
    const impacts = initiative.impact || [];

    if (impacts.length === 0) {
      impactGroups['<not set>'].push(initiative);
      return;
    }

    const hasActualsInFY2324 = impacts.some((impact) => {
      return (
        impact.annuallyActual &&
        impact.annuallyActual[0] &&
        impact.annuallyActual[0] !== undefined &&
        impact.annuallyActual[0] !== null
      );
    });

    const hasMissingActualsInFY2324 = impacts.some((impact) => {
      return (
        impact.annuallyActual &&
        impact.annuallyActual[0] &&
        (impact.annuallyActual[0] === undefined || impact.annuallyActual[0] === null)
      );
    });

    const isBelowL3OrCancelledOrOnHold =
      initiative.stage && ['L0', 'L1', 'L2'].includes(initiative.stage);
    const isCancelledOrOnHold =
      initiative.weeklyStatus && ['Cancelled', 'On hold'].includes(initiative.weeklyStatus);

    if (isBelowL3OrCancelledOrOnHold || isCancelledOrOnHold) {
      impactGroups['No actuals (below L3 or cancelled/on hold)'].push(initiative);
    } else if (
      impacts.every(
        (impact) =>
          !impact.annuallyActual ||
          !impact.annuallyActual[0] ||
          impact.annuallyActual[0] === undefined ||
          impact.annuallyActual[0] === null
      )
    ) {
      impactGroups['No actuals required or no impacts'].push(initiative);
    } else if (hasMissingActualsInFY2324) {
      impactGroups['Missing actual in FY 23-24'].push(initiative);
    } else if (hasActualsInFY2324) {
      impactGroups['Filled actual in FY 23-24'].push(initiative);
    } else {
      impactGroups['<not set>'].push(initiative);
    }
  });

  return impactGroups;
};

export default filterInitiativesByImpactUpdate;
